import React, { Component } from 'react'
import Footer from '../footer/newfooter'
import Header from '../header/newheader'
import "./podcast.css"
import mic from '../assets/podcast.png'
import Slider from "react-slick";
import play from '../assets/episodeplay.png'
import larrow from '../assets/larrow.png'
import bullet from '../assets/bullet.png'
import Axios from 'axios'
import { BASE } from '../api/api'
import HtmlParser from 'react-html-parser'
import AllTopics from './alltopics'
import MailChimp from './mailchimp'
import { Link } from 'react-router-dom'

class Podcast extends Component {
    constructor(props) {
        super(props)
        this.state = {
            podcast: null,
            episodes: null,
            topics: null,
            episodeInclude: [],
            topicInclude: [],
            seeAll: window.innerWidth < 575 ? false : true
        }
    }
    componentDidMount() {
        // https://soundcloud.com/user-326670852/ohi-aa-ni-ohi-aa-karan-bajwa
        window.scrollTo(0, 0)
        this.props.history.push("/podcast")
        Axios.get(`${BASE}jsonapi/node/podcast?include=field_topic,field_episode_thumbnail&sort[sort-created][path]=created&sort[sort-created][direction]=DESC&page[offset]=0&page[limit]=6`)
            .then(data => {
                console.log("episodes", data.data.data)
                this.setState({
                    episodes: data.data.data,
                    episodeInclude: data.data.included
                })
            })
        Axios.get(`${BASE}jsonapi/taxonomy_term/topic`)
            .then(data => {
                console.log("topics", data.data.data)
                this.setState({
                    topics: data.data.data,
                    topicInclude: data.data.included
                })
            })
    }
    render() {
        return (
            <div className='podcast' id="podcast">
                <Header />
                <div className='full-data'>
                    <div className='top-back desk-only'>
                        <div className='container top-back-container'>
                            <div className='flex-row left-row'>
                                <div className='w-50 left'>
                                    <div className='podcast-subHead'>I-BIR Podcast</div>
                                    <div className='headings'>
                                        Progress
                                    </div>
                                    <p className='podcast-main-description'>
                                        The faculty members at HBKU apply creativity to education in order to address the mission of building a knowledge-based community.
                                        Through their podcast series, faculty members at HBKU endeavor to create a dynamic learning community by providing value-added knowledge to the students and global audience.
                                        Podcast has been slow to find a place in the scholarly world, and HBKU’s academic podcasters are trying to change that. Engaging in conversations with key members of the HBKU and stakeholders, or by recording audio-video notes on relevant issues of the society,
                                        CIS faculty aims to reach to widest audience possible by using the latest ease-of-use recording technologies.
                                    </p>
                                    {/* <div className='flex-row buttons'>
                                        <a href="#topics" className='button1'>
                                            See All Topics
                                        </a>
                                        <a href='#listening' className='button2'>
                                            Start Listening
                                        </a>
                                    </div> */}
                                </div>
                                <div className='w-50 top-back-right'>
                                    <p className='podcast-subHead right-align'>اي - بر تدوين صوتي</p>
                                    <div className='headings'>
                                        مُستدام
                                    </div>
                                    <p dir='rtl' className='podcast-main-description right-align'>
                                        يسعى أعضاء هيئة التدريس في جامعة حمد بن خليفة إلى إنشاء مجتمع تعليمي ديناميكي من خلال توفير المعرفة ذات القيمة المضافة للطلاب والجمهور العالمي وذلك من خلال سلسلة البودكاست (البث الصوتي). وهذا سعيًا للإبداع في التعليم من أجل معالجة مهمة بناء مجتمع قائم على المعرفة. فمن خلال المحادثات العلمية مع الأعضاء الرئيسيين في جامعة حمد بن خليفة والجهات المعنية أو من خلال التسجيلات الصوتية والمرئية حول القضايا ذات الصلة بالمجتمع ، تهدف كلية الدراسات الإسلامية إلى الوصول إلى أوسع جمهور ممكن باستخدام أحدث تقنيات التسجيل سهلة الاستخدام.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='top-back mob-only'>
                        <div className='top-back-top'>
                            <div className='container'>
                                <div className='podcast-subHead'>I-BIR Podcast</div>
                                <div className='headings'>
                                    Progress
                                </div>
                                <p className='podcast-main-description'>
                                    A podcast about sustainability with perspectives on and from the Middle East.
                                    <br />
                                    Arabic and English episodes are published monthly. Issues we have or will cover will include: sustainable cities, energy, health, education and behavior change, carbon neutrality, water conservation, pollution, plastics, food security, agriculture, transportation, built environment, and many more.
                                    <br />
                                    Brought to you by the Program on Governance, Resilience and Sustainability (PROGRESS) in the College of Public Policy and the College of Islamic Studies, both at Hamad Bin Khalifa University in Qatar.
                                </p>
                                {/* <div className='flex-row buttons '>
                                    <a href="#topics" className='button1'>
                                        See All Topics
                                    </a>
                                    <a href='#listening' className='button2'>
                                        Start Listening
                                    </a>
                                </div> */}
                            </div>
                        </div>
                        <div className='top-back-bottom'>
                            <div className='container'>
                                <div className='podcast-subHead right-align'>اي-بر تدوين صوتي </div>
                                <div className='headings right-align'>
                                    مُستدام
                                </div>
                                <p dir='rtl' className='podcast-main-description right-align'>
                                    برنامج "مُستدام"حول الاستدامة في الشرق الأوسط وشمال أفريقيا.
                                    <br />
                                    تُنشر الحلقات باللغتين العربية والانجليزية من كل شهر، تتناول قضايا حول المدن المستدامة، والطاقة والصحة، والتعليم، وتغير السلوك، والكربون والمحافظة على المياه، والتلوث، والبلاستيك، والأمن الغذائي، والزراعة، والنقل، والبيئة وغيرها الكثير.
                                    <br />
                                    كما نقدم لكم برنامجاً حول الحوكمة، والقدرة على التكيف والاستدامة (مُستدام) بالتعاون بين كلية السياسات العامة وكلية الدراسات الإسلامية بجامة حمد بن خليفة في قطر.
                                </p>
                                {/* <div className='flex-row buttons end-flex'>
                                    <a href="#topics" className='button1 right-align'>
                                        جميع الحلقات
                                    </a>
                                    <a href='#listening' className='button2 right-align'>
                                        استمع الآن
                                    </a>
                                </div> */}
                            </div>
                        </div>
                    </div>
                    {/* <div className='container' id='listening'>
                        <div className='latest-heading'>
                            Latest Episodes
                        </div>
                        <div className='flex-wrap latest'>
                            {this.state.episodes ? this.state.episodes.map((item, ind) => {
                                let aa = item.attributes.title.toString()
                                let link = aa.replace(/ /g, '-')
                                let links = link.replace(/\?/g, "")
                                let lang = item.attributes.field_podcast_language ? item.attributes.field_podcast_language == "arabic" ? "arabic" : "english" : "english"
                                let thumbnail = item.relationships.field_episode_thumbnail.data ? this.state.episodeInclude.filter(x => x.id == item.relationships.field_episode_thumbnail.data.id).length ? this.state.episodeInclude.filter(x => x.id == item.relationships.field_episode_thumbnail.data.id)[0].attributes.uri.url : "" : ""
                                console.log("thumbnail", item.relationships.field_episode_thumbnail.data ? this.state.episodeInclude.filter(x => x.id == item.relationships.field_episode_thumbnail.data.id) : "")
                                let episode = item.attributes.field_number_of_episode < 10 ? `0${item.attributes.field_number_of_episode}` : item.attributes.field_number_of_episode
                                if (this.state.seeAll) {
                                    return (
                                        <div className={lang ? lang == "arabic" ? "right-align w-32" : "left w-32" : "left w-32"} style={{ marginRight: (ind + 1) % 3 == 0 ? "0" : "2%" }}>
                                            <div className='latest-image-container'>
                                                <img className='latest-img' src={thumbnail ? `${BASE}${thumbnail}` : "/cluster/c1.png"} />
                                                <div className='ep-count'>{item.attributes.field_number_of_episode ? lang == "arabic" ? `EP ${episode} A` : `EP ${episode} E` : ""}</div>
                                            </div>
                                            <Link to={`/podcast/${links}?id=${item.id}`} onClick={() => window.scrollTo(0, 0)} className='title'>{item.attributes.title ? item.attributes.title : ""}</Link>
                                            <p className='description'>{item.attributes.field_short_description ? HtmlParser(item.attributes.field_short_description.value) : ""}</p>
                                            <div className='flex-row play-div'>
                                                <Link to={`/podcast/${links}?id=${item.id}`} onClick={() => window.scrollTo(0, 0)} className='play-button'>
                                                    <span><img src={play} /></span>  Play this episode
                                                </Link>
                                                <div className="mins">{item.attributes.field__podcast_length ? item.attributes.field__podcast_length + " min" : ""}</div>
                                            </div>
                                        </div>
                                    )
                                }
                                else {
                                    if (ind < 3)
                                        return (
                                            <div className='w-32' style={{ marginRight: (ind + 1) % 3 == 0 ? "0" : "2%", textAlign: lang ? lang == "arabic" ? "right" : "left" : "left" }}>
                                                <div className='latest-image-container'>
                                                    <img className='latest-img' src={thumbnail ? `${BASE}${thumbnail}` : "/cluster/c1.png"} />
                                                    <div className='ep-count'>{item.attributes.field_number_of_episode ? lang == "arabic" ? `EP ${episode} A` : `EP ${episode} E` : ""}</div>
                                                </div>
                                                <Link to={`/podcast/${links}`} onClick={() => window.scrollTo(0, 0)} className='title'>{item.attributes.title ? item.attributes.title : ""}</Link>
                                                <p className='description'>{item.attributes.field_short_description ? HtmlParser(item.attributes.field_short_description.value) : ""}</p>
                                                <div className='flex-row play-div'>
                                                    <Link to={`/podcast/${links}?id=${item.id}`} onClick={() => window.scrollTo(0, 0)} className='play-button'>
                                                        <span><img src={play} /></span>  Play this episode
                                                    </Link>
                                                    <div className="mins">{item.attributes.field__podcast_length ? item.attributes.field__podcast_length + " min" : ""}</div>
                                                </div>
                                            </div>
                                        )
                                }

                            })
                                : ""}

                        </div>
                        {this.state.seeAll ? "" :
                            <div className='see-all-button mob-only' onClick={() => { this.setState({ seeAll: true }) }}>See All Topics</div>
                        }
                    </div> */}
                    <div id='topics'>
                        <AllTopics />
                    </div>
                    {/* <MailChimp /> */}
                </div>

                <Footer />
            </div>
        )
    }
} export default Podcast;